import React, {useState, useEffect} from "react";
import Address from "./Address";
import Offer from "./Offer";
import Pet from "./Pet";
import PetDetails from "./PetDetails";
import Profile from "./Profile";
import AddPhoto from "./AddPhoto";
import SubscriptionWelcome from "./SubscriptionWelcome";
import { LinearProgress,
    useMediaQuery,
    Theme,
    withStyles,
    createStyles,
    makeStyles } from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {useHistory,useLocation} from "react-router-dom";
import {getGuestBookingResumePath, resolveAppointmentDraftDefaults} from "../../../utils/guestBooking";
import {setPetType} from "../../../utils/petInfo";

interface Props {
	isOnBoarding: boolean;
	setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>;
}

const useStyle = makeStyles(() => ({
    itemContainer: {
        marginBottom: "25px"
    },
    hidden: {
        display: "none"
    }
}));

const CustomLinearProgress = withStyles((theme: Theme) =>
    createStyles({
        root: {
            height: 10,
            borderRadius: 5,
        },
        bar: {
            borderRadius: 5,
            backgroundColor: "primary",
        },
    }),
)(LinearProgress);

const UserOnBoarding = ({ isOnBoarding, setIsOnBoarding }: Props) => {
    const theme = useTheme();
    const locationObj = useLocation();
    const hasSubscription = locationObj.state ? locationObj.state["hasSubscription"] : false;
    const [count, setCount] = useState(hasSubscription ? 0 : 1);
    const classes = useStyle();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);
    const branding = useSelector((state: RootState) => state?.branding);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const [petId, setPetId] = useState(0);
    const [pet, setPet] = useState(useSelector((state: RootState) => state?.pets.selectedPet));
    const history = useHistory();

    const [animalType, setAnimalType] = useState("Other");
    const [initialPetType, setInitialPetType] = useState("");

    const changeCount = (number: number) => {
        let newNumber = count + number;
        setCount(newNumber);
    };

    useEffect(() => {
        resolveAppointmentDraftDefaults().then(({animalType: draftAnimalType}) => {
            if (!draftAnimalType) {
                return;
            }
            setInitialPetType(draftAnimalType);
            setAnimalType(setPetType(draftAnimalType));
        });
    }, []);

    useEffect(() => {
        if (!isOnBoarding){
            history.push(getGuestBookingResumePath() || "/schedule");
        }
    }, []);

    return(
        <>
            {count < 6 && count > 0 &&
                <CustomLinearProgress variant="determinate" color="secondary" value={Math.round((count/5)*100)}/>
            }
            {count === 0 &&
				<SubscriptionWelcome changeCount={changeCount} />
            }
            {count === 1 &&
                <Profile changeCount={changeCount} hasSubscription={hasSubscription}/>
            }
            {count === 2 &&
                <Address changeCount={changeCount} />
            }
            {count === 3 &&
                <Pet
                	changeCount={changeCount}
                	isWhiteLabel={isWhiteLabel}
                	petId={petId}
                	setPetId={setPetId}
                	pet={pet}
                	setPet={setPet}
                	animalType={animalType}
                	setAnimalType={setAnimalType}
                	initialPetType={initialPetType}
                />
            }
            {count === 4 &&
                <AddPhoto
                	petId={petId}
                	isWhiteLabel={isWhiteLabel}
                	animalType={animalType}
                	changeCount={changeCount}
                />
            }
            {count === 5 &&
                <PetDetails
                	changeCount={changeCount}
                	isWhiteLabel={isWhiteLabel}
                	petId={petId}
                	setPetId={setPetId}
                	pet={pet}
                	setPet={setPet}
                    isOnBoarding={isOnBoarding}
                />
            }
            {count === 6 &&
                <Offer pet={pet} isOnBoarding={isOnBoarding} setIsOnBoarding={setIsOnBoarding} hasSubscription={hasSubscription} />
            }
        </>
    );
};

export default UserOnBoarding;
